import { render, staticRenderFns } from "./carRent.vue?vue&type=template&id=24f8cb01&scoped=true"
import script from "./carRent.vue?vue&type=script&lang=js"
export * from "./carRent.vue?vue&type=script&lang=js"
import style0 from "./carRent.vue?vue&type=style&index=0&id=24f8cb01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f8cb01",
  null
  
)

export default component.exports